// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
export const VIDEO_ACTION = {
  SAVE_WATCHED_TIME: 'STUDENT/VIDEO_ACTION/SAVE_WATCHED_TIME',
};
